(() => {
  const SECTION_IDS = ['cart-drawer', 'cart-icon-bubble'];

  const jsonHeaders = { 'Content-Type': 'application/json', Accept: 'application/json' };
  const root = () => (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  const cartUrl = () => (window.routes && window.routes.cart_url) || `${root()}cart`;
  const addUrl = () => (window.routes && window.routes.cart_add_url) || `${root()}cart/add`;
  const changeUrl = () => (window.routes && window.routes.cart_change_url) || `${root()}cart/change`;
  const updateUrl = () => (window.routes && window.routes.cart_update_url) || `${root()}cart/update`;
  const endpoint = (url) => (url.endsWith('.js') ? url : `${url}.js`);

 const isCartUpsellEnabled = () => true;

  const parsePlanId = (value) => {
    if (value === null || value === undefined || value === '') return null;
    const match = String(value).match(/(\d+)$/);
    return match ? Number(match[1]) : null;
  };

  const planIdForItem = (item) => parsePlanId(
    item && item.selling_plan_allocation && item.selling_plan_allocation.selling_plan
      ? item.selling_plan_allocation.selling_plan.id
      : null
  );

  const isSubscription = (item) => Boolean(planIdForItem(item));
  const byProduct = (cart, productId) => cart.items.filter((item) => Number(item.product_id) === Number(productId));
  const firstByProduct = (cart, productId, predicate = () => true) => byProduct(cart, productId).find(predicate) || null;
  const hasProduct = (cart, productId) => byProduct(cart, productId).length > 0;

  const money = (cents, currency = 'USD') => {
    if (!Number.isFinite(Number(cents))) return '';
    try {
      return new Intl.NumberFormat(undefined, { style: 'currency', currency }).format(Number(cents) / 100);
    } catch (_error) {
      return `$${(Number(cents) / 100).toFixed(2)}`;
    }
  };

  const requestJson = async (url, options = {}) => {
    const response = await fetch(url, options);
    let data = null;

    try {
      data = await response.json();
    } catch (_error) {
      data = null;
    }

    if (!response.ok) {
      const message = data && (data.description || data.message)
        ? data.description || data.message
        : `Request failed (${response.status})`;
      throw new Error(message);
    }

    return data;
  };

  const sectionsPayload = () => ({
    sections: SECTION_IDS,
    sections_url: window.location.pathname || '/',
  });

  const pushEvent = (event, rule, extra = {}) => {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event,
      cart_upsell_rule_id: rule ? rule.id : undefined,
      cart_upsell_offer_type: rule ? rule.type : undefined,
      cart_upsell_target_product_id: rule && rule.target ? rule.target.productId : undefined,
      cart_upsell_target_variant_id: rule && rule.target ? rule.target.variantId : undefined,
      cart_upsell_selling_plan_id: rule ? rule.sellingPlanId || undefined : undefined,
      ...extra,
    });
  };

  const makeOffer = ({
    id,
    type,
    target,
    sellingPlanId = null,
    sourceItem = null,
    removeProductIds = [],
    eyebrow,
    benefit,
    cta,
    replacementNote = '',
    perks = [],
    action,
  }) => ({
    id,
    type,
    target,
    sellingPlanId: parsePlanId(sellingPlanId),
    sourceItem,
    removeProductIds: removeProductIds.map(Number),
    eyebrow,
    benefit,
    cta,
    replacementNote,
    perks,
    action,
  });

  const chooseRule = (cart, config) => {
    const p = config.products;
    const plans = config.sellingPlans;

    const bundleProductIds = [
      p.serumBundle1.productId,
      p.serumBundle2.productId,
      p.serumBundle3.productId,
      p.serumBundle6.productId,
    ].map(Number);

    const standaloneSerumProducts = [
      { family: 'treatment', pack: 1, product: p.treatment, plan: null },
      { family: 'treatment', pack: 2, product: p.treatment2, plan: plans.treatment2 },
      { family: 'treatment', pack: 3, product: p.treatment3, plan: plans.treatment3 },
      { family: 'prevention', pack: 1, product: p.prevention, plan: null },
      { family: 'prevention', pack: 2, product: p.prevention2, plan: plans.prevention2 },
      { family: 'prevention', pack: 3, product: p.prevention3, plan: plans.prevention3 },
    ];

    const standaloneSerumProductIds = standaloneSerumProducts.map(({ product }) => Number(product.productId));
    const serumBundleItems = cart.items.filter((item) => bundleProductIds.includes(Number(item.product_id)));
    const serumSubscriptionItems = serumBundleItems.filter(isSubscription);
    const standaloneSerumItems = cart.items.filter((item) => standaloneSerumProductIds.includes(Number(item.product_id)));

    const hasSerumBundle = serumBundleItems.length > 0;
    const hasSerumSubscription = serumSubscriptionItems.length > 0;
    const hasStandaloneSerums = standaloneSerumItems.length > 0;

    const hasShampoo = hasProduct(cart, p.shampoo.productId);
    const hasConditioner = hasProduct(cart, p.conditioner.productId);
    const hasScBundle = hasProduct(cart, p.scBundle.productId);
    const hasCompleteSc = hasScBundle || (hasShampoo && hasConditioner);

    const serum1Otp = firstByProduct(cart, p.serumBundle1.productId, (item) => !isSubscription(item));
    const serum1Sub = firstByProduct(cart, p.serumBundle1.productId, isSubscription);
    const serum3Otp = firstByProduct(cart, p.serumBundle3.productId, (item) => !isSubscription(item));
    const serum6Otp = firstByProduct(cart, p.serumBundle6.productId, (item) => !isSubscription(item));

    const validTarget = (target) => target && Number(target.variantId) > 0;

    const standaloneItems = (family, pack) => {
      const match = standaloneSerumProducts.find((entry) => entry.family === family && entry.pack === pack);
      return match ? byProduct(cart, match.product.productId) : [];
    };

    const standaloneEntry = (family, pack) => standaloneSerumProducts.find(
      (entry) => entry.family === family && entry.pack === pack
    );

    const matchingPair = (pack) => {
      const treatmentItems = standaloneItems('treatment', pack);
      const preventionItems = standaloneItems('prevention', pack);
      if (!treatmentItems.length || !preventionItems.length) return null;
      return {
        pack,
        treatmentItems,
        preventionItems,
        items: [...treatmentItems, ...preventionItems],
        isSubscription: [...treatmentItems, ...preventionItems].some(isSubscription),
      };
    };

    const pairedStandalone = matchingPair(3) || matchingPair(2) || matchingPair(1);

    const targetForPack = (pack) => {
      if (pack === 3) return { product: p.serumBundle3, plan: plans.serumBundle3 };
      if (pack === 2) return { product: p.serumBundle2, plan: plans.serumBundle2 };
      return { product: p.serumBundle1, plan: plans.serumBundle1 };
    };

    const counterpartOffer = (sourceFamily, pack) => {
      const sourceItems = standaloneItems(sourceFamily, pack);
      const targetFamily = sourceFamily === 'treatment' ? 'prevention' : 'treatment';
      const targetEntry = standaloneEntry(targetFamily, pack);
      if (!sourceItems.length || standaloneItems(targetFamily, pack).length || !targetEntry || !validTarget(targetEntry.product)) {
        return null;
      }

      const sourceIsSub = sourceItems.some(isSubscription);
      const sellingPlanId = sourceIsSub ? targetEntry.plan : null;
      const familyLabel = targetFamily === 'treatment' ? 'Treatment' : 'Prevention';
      const packLabel = pack > 1 ? `${pack}-Pack ` : '';

      return makeOffer({
        id: `KM_CART_UPSELL_STANDALONE_${sourceFamily.toUpperCase()}${pack}_TO_${targetFamily.toUpperCase()}${pack}${sellingPlanId ? '_SUB' : '_OTP'}`,
        type: 'add_on',
        target: targetEntry.product,
        sellingPlanId,
        eyebrow: 'Complete the serum system',
        benefit: `Pair your ${sourceFamily === 'treatment' ? 'Treatment' : 'Prevention'} Serum with the matching ${familyLabel} Serum ${packLabel.toLowerCase()}for a complete dual-action routine.`,
        cta: `Add ${familyLabel} ${packLabel}Serum`,
        perks: [
          'Dual-action routine',
          pack > 1 ? `${pack}-month supply` : 'Complements routine',
          sellingPlanId ? 'Auto-refills' : 'Easy to use',
        ],
        action: 'add',
      });
    };

    // 1. 1-month Serum Bundle OTP + complete S&C -> 3-month Serum Bundle subscription.
    if (serum1Otp && hasCompleteSc && validTarget(p.serumBundle3) && plans.serumBundle3) return makeOffer({
      id: 'KM_CART_UPSELL_01_SERUM1_OTP_SC_TO_SERUM3_SUB',
      type: 'replacement',
      target: p.serumBundle3,
      sellingPlanId: plans.serumBundle3,
      sourceItem: serum1Otp,
      eyebrow: 'Clinically recommended 90-day routine',
      benefit: 'Upgrade to the clinically recommended 90-day routine while keeping your Shampoo & Conditioner in place.',
      cta: 'Upgrade to 3-month subscription',
      replacementNote: 'Replaces your 1-month serum bundle. Your Shampoo & Conditioner stay in the cart.',
      perks: ['Clinically recommended', '90-day routine', 'Easy to edit'],
      action: 'replace_variant',
    });

    // 2. Matching standalone Treatment + Prevention products with complete S&C
    // -> replace all standalone serum lines with the matching Serum Bundle subscription.
    if (pairedStandalone && hasCompleteSc) {
      const bundleTarget = targetForPack(pairedStandalone.pack);
      if (validTarget(bundleTarget.product) && bundleTarget.plan) return makeOffer({
        id: `KM_CART_UPSELL_STANDALONE_PAIR${pairedStandalone.pack}_SC_TO_SERUM_BUNDLE${pairedStandalone.pack}_SUB`,
        type: 'replacement',
        target: bundleTarget.product,
        sellingPlanId: bundleTarget.plan,
        removeProductIds: standaloneSerumProductIds,
        eyebrow: pairedStandalone.pack === 3 ? 'Clinically recommended 90-day routine' : 'Upgrade to the complete serum bundle',
        benefit: pairedStandalone.pack === 3
          ? 'Replace the separate serums with the clinically recommended 90-day Serum Bundle subscription.'
          : 'Replace the separate Treatment and Prevention products with the matching Serum Bundle subscription.',
        cta: pairedStandalone.pack === 3 ? 'Upgrade to 3-month subscription' : `Upgrade to ${pairedStandalone.pack}-month bundle subscription`,
        replacementNote: 'Replaces the separate Treatment and Prevention line items. Your Shampoo & Conditioner stay in the cart.',
        perks: pairedStandalone.pack === 3
          ? ['Clinically recommended', '90-day routine', 'No duplicate serums']
          : [`${pairedStandalone.pack}-month supply`, 'Bundle subscription', 'No duplicate serums'],
        action: 'add_bundle_remove_standalone_serums',
      });
    }

    // 3. A standalone 2-pack or 3-pack is missing its matching counterpart.
    // Preserve subscription status when the corresponding selling plan is configured.
    for (const pack of [3, 2]) {
      const treatmentOffer = counterpartOffer('treatment', pack);
      if (treatmentOffer) return treatmentOffer;

      const preventionOffer = counterpartOffer('prevention', pack);
      if (preventionOffer) return preventionOffer;
    }

    // 4. Matching standalone Treatment + Prevention products without complete S&C
    // -> add S&C bundle. Subscription serum pairs receive the S&C subscription.
    if (pairedStandalone && !hasCompleteSc && validTarget(p.scBundle)) return makeOffer({
      id: pairedStandalone.isSubscription
        ? 'KM_CART_UPSELL_STANDALONE_PAIR_TO_SC_BUNDLE_SUB'
        : 'KM_CART_UPSELL_STANDALONE_PAIR_TO_SC_BUNDLE_OTP',
      type: 'add_on',
      target: p.scBundle,
      sellingPlanId: pairedStandalone.isSubscription ? plans.scBundle : null,
      eyebrow: 'Build the complete system',
      benefit: 'Prepare the scalp and protect fragile new growth with the complete wash-day duo.',
      cta: pairedStandalone.isSubscription ? 'Add S&C subscription' : 'Add Shampoo & Conditioner',
      perks: ['Wash-day duo', 'Supports scalp care', pairedStandalone.isSubscription ? 'Auto-refills' : 'Easy to use'],
      action: 'add',
    });

    // 5. 3-month Serum Bundle OTP -> same variant with subscription selling plan.
    if (serum3Otp && validTarget(p.serumBundle3) && plans.serumBundle3) return makeOffer({
      id: 'KM_CART_UPSELL_05_SERUM3_OTP_TO_SUB',
      type: 'replacement',
      target: p.serumBundle3,
      sellingPlanId: plans.serumBundle3,
      sourceItem: serum3Otp,
      eyebrow: 'Clinically recommended 90-day routine',
      benefit: 'Keep your clinically recommended 90-day routine consistent and receive the subscription price.',
      cta: 'Switch to 3-month subscription',
      replacementNote: 'Updates your existing 3-month bundle. It will not add a second bundle.',
      perks: ['Clinically recommended', 'Lower price', 'Easy to edit'],
      action: 'change_plan',
    });

    // 6. 6-month Serum Bundle OTP without complete S&C -> add S&C bundle OTP.
    if (serum6Otp && !hasCompleteSc && validTarget(p.scBundle)) return makeOffer({
      id: 'KM_CART_UPSELL_06_SERUM6_OTP_TO_SC_BUNDLE_OTP',
      type: 'add_on',
      target: p.scBundle,
      eyebrow: 'Build the complete system',
      benefit: 'Add the wash-day duo designed to support the serum routine.',
      cta: 'Add Shampoo & Conditioner',
      perks: ['Wash-day duo', 'Supports scalp care', 'Easy to use'],
      action: 'add',
    });

    // 7. 1-month Serum Bundle subscription -> 3-month Serum Bundle subscription.
    if (serum1Sub && validTarget(p.serumBundle3) && plans.serumBundle3) return makeOffer({
      id: 'KM_CART_UPSELL_07_SERUM1_SUB_TO_SERUM3_SUB',
      type: 'replacement',
      target: p.serumBundle3,
      sellingPlanId: plans.serumBundle3,
      sourceItem: serum1Sub,
      eyebrow: 'Clinically recommended 90-day routine',
      benefit: 'Move to the clinically recommended 90-day supply so your routine stays uninterrupted.',
      cta: 'Upgrade to 3-month subscription',
      replacementNote: 'Replaces your 1-month serum subscription with the 3-month subscription.',
      perks: ['Clinically recommended', '90-day routine', 'Easy to edit'],
      action: 'replace_variant',
    });

    // 8. 1-month Serum Bundle OTP -> same variant with subscription selling plan.
    if (serum1Otp && validTarget(p.serumBundle1) && plans.serumBundle1) return makeOffer({
      id: 'KM_CART_UPSELL_08_SERUM1_OTP_TO_SUB',
      type: 'replacement',
      target: p.serumBundle1,
      sellingPlanId: plans.serumBundle1,
      sourceItem: serum1Otp,
      eyebrow: 'Subscribe & save',
      benefit: 'Stay consistent and receive the subscription price.',
      cta: 'Switch to subscription',
      replacementNote: 'Updates your existing 1-month bundle. It will not add a second bundle.',
      perks: ['Auto-refills', 'Lower price', 'Easy to edit'],
      action: 'change_plan',
    });

    // 9. Serum Bundle subscription without any S&C products -> add S&C bundle subscription.
    if (hasSerumSubscription && !hasShampoo && !hasConditioner && !hasScBundle && validTarget(p.scBundle) && plans.scBundle) return makeOffer({
      id: 'KM_CART_UPSELL_09_SERUM_SUB_TO_SC_SUB',
      type: 'add_on',
      target: p.scBundle,
      sellingPlanId: plans.scBundle,
      eyebrow: 'Build the complete system',
      benefit: 'Add the Shampoo & Conditioner subscription bundle for your wash-day routine.',
      cta: 'Add S&C subscription',
      perks: ['Auto-refills', 'Wash-day duo', 'Easy to edit'],
      action: 'add',
    });

    // 10. Complete S&C without any serum bundle or standalone serum products
    // -> add 1-month Serum Bundle subscription.
    if (hasCompleteSc && !hasSerumBundle && !hasStandaloneSerums && validTarget(p.serumBundle1) && plans.serumBundle1) return makeOffer({
      id: 'KM_CART_UPSELL_10_SC_TO_SERUM1_SUB',
      type: 'add_on',
      target: p.serumBundle1,
      sellingPlanId: plans.serumBundle1,
      eyebrow: 'Build the complete system',
      benefit: 'Pair your wash-day routine with the dual-action serum system.',
      cta: 'Add serum subscription',
      perks: ['Auto-refills', 'Lower price', 'Easy to edit'],
      action: 'add',
    });

    // 11. Shampoo only -> add Conditioner OTP.
    if (hasShampoo && !hasConditioner && !hasScBundle && validTarget(p.conditioner)) return makeOffer({
      id: 'KM_CART_UPSELL_11_SHAMPOO_TO_CONDITIONER',
      type: 'add_on',
      target: p.conditioner,
      eyebrow: 'Complete the duo',
      benefit: 'Add the conditioner to strengthen and protect fragile new growth.',
      cta: 'Add Conditioner',
      perks: ['Completes the duo', 'Supports fragile hair', 'Easy to use'],
      action: 'add',
    });

    // 12. Conditioner only -> add Shampoo OTP.
    if (hasConditioner && !hasShampoo && !hasScBundle && validTarget(p.shampoo)) return makeOffer({
      id: 'KM_CART_UPSELL_12_CONDITIONER_TO_SHAMPOO',
      type: 'add_on',
      target: p.shampoo,
      eyebrow: 'Complete the duo',
      benefit: 'Add the shampoo to gently cleanse and prepare the scalp.',
      cta: 'Add Shampoo',
      perks: ['Completes the duo', 'Cleanses scalp', 'Easy to use'],
      action: 'add',
    });

    // 13. Single Treatment Serum only -> add single Prevention Serum OTP.
    const treatment1Offer = counterpartOffer('treatment', 1);
    if (treatment1Offer) return treatment1Offer;

    // 14. Single Prevention Serum only -> add single Treatment Serum OTP.
    const prevention1Offer = counterpartOffer('prevention', 1);
    if (prevention1Offer) return prevention1Offer;

    return null;
  };

  const targetPrice = (rule) => {
    if (rule.sellingPlanId && Number(rule.target.subscriptionPrice) > 0) {
      return Number(rule.target.subscriptionPrice);
    }
    return Number(rule.target.otpPrice) || 0;
  };

  const savingsBadge = (rule) => {
    const otp = Number(rule.target.otpPrice) || 0;
    const offered = targetPrice(rule);

    if (rule.sellingPlanId && otp > offered && offered > 0) {
      return `Save ${Math.round((1 - offered / otp) * 100)}%`;
    }

    return rule.type === 'replacement' ? 'Upgrade' : 'Recommended';
  };

  const defaultPerks = (rule) => {
    const isThreeMonthSerumSubscription = Number(rule.target.productId) === 10564718788911 && Boolean(rule.sellingPlanId);

    if (isThreeMonthSerumSubscription) return ['Clinically recommended', '90-day routine', 'Easy to edit'];
    if (rule.sellingPlanId) return ['Auto-refills', 'Lower price', 'Easy to edit'];
    if (rule.type === 'replacement') return ['Higher-value option', 'Replaces current item', 'No duplicate bundle'];
    return ['Complements routine', 'Added to cart', 'Easy to use'];
  };

  class KmCartUpsell extends HTMLElement {
    connectedCallback() {
      this.activate();
    }

    activate() {
      if (!isCartUpsellEnabled()) {
        this.hidden = true;
        return;
      }

      if (this.dataset.kmInitialized === 'true') return;

      this.dataset.kmInitialized = 'true';
      this.config = this.readConfig();
      this.acceptButton = this.querySelector('[data-km-upsell-accept]');
      this.dismissButton = this.querySelector('[data-km-upsell-dismiss]');

      if (this.acceptButton) this.acceptButton.addEventListener('click', () => this.accept());
      if (this.dismissButton) this.dismissButton.addEventListener('click', () => this.dismiss());

      const embeddedCart = this.readEmbeddedCart();
      if (embeddedCart) this.applyCart(embeddedCart);
      else this.evaluate();
    }

    readConfig() {
      const node = this.querySelector('[data-km-cart-upsell-config]');
      if (!node) return null;

      try {
        return JSON.parse(node.textContent);
      } catch (error) {
        console.error('[KM cart upsell] Invalid config JSON', error);
        return null;
      }
    }

    readEmbeddedCart() {
      const node = this.querySelector('[data-km-cart-upsell-cart]');
      if (!node) return null;

      try {
        return JSON.parse(node.textContent);
      } catch (error) {
        console.error('[KM cart upsell] Invalid embedded cart JSON', error);
        return null;
      }
    }

    applyCart(cart) {
      if (!this.config || !cart) return;

      const rule = chooseRule(cart, this.config);
      if (!rule) {
        this.hidden = true;
        this.cart = cart;
        this.rule = null;
        this.lastImpressionKey = null;
        return;
      }

      this.cart = cart;
      this.rule = rule;
      this.render(cart, rule);

      const impressionKey = [rule.id, cart.item_count, cart.total_price].join(':');
      if (this.lastImpressionKey !== impressionKey) {
        this.lastImpressionKey = impressionKey;
        pushEvent('cart_upsell_impression', rule, { cart_value_before: cart.total_price });
      }
    }

    async evaluate() {
      if (!isCartUpsellEnabled() || !this.config) return;

      try {
        const cart = await requestJson(endpoint(cartUrl()));
        this.applyCart(cart);
      } catch (error) {
        console.error('[KM cart upsell] Evaluation failed', error);
        if (!this.rule) this.hidden = true;
      }
    }

    render(cart, rule) {
      const image = this.querySelector('[data-km-upsell-image]');
      if (image) {
        image.src = rule.target.image || '';
        image.alt = rule.target.title || '';
      }

      const eyebrow = this.querySelector('[data-km-upsell-eyebrow]');
      if (eyebrow) eyebrow.textContent = rule.eyebrow;

      const title = this.querySelector('[data-km-upsell-title]');
      if (title) title.textContent = rule.target.title;

      const benefit = this.querySelector('[data-km-upsell-benefit]');
      if (benefit) benefit.textContent = rule.benefit;

      const offeredPrice = targetPrice(rule);
      const otpPrice = Number(rule.target.otpPrice) || 0;

      const price = this.querySelector('[data-km-upsell-price]');
      if (price) price.textContent = money(offeredPrice, cart.currency || 'USD');

      const comparePrice = this.querySelector('[data-km-upsell-compare-price]');
      if (comparePrice) {
        const showComparePrice = Boolean(rule.sellingPlanId) && otpPrice > offeredPrice && offeredPrice > 0;
        comparePrice.textContent = showComparePrice ? `One-time price ${money(otpPrice, cart.currency || 'USD')}` : '';
        comparePrice.hidden = !showComparePrice;
      }

      const badge = this.querySelector('[data-km-upsell-badge]');
      if (badge) {
        badge.textContent = savingsBadge(rule);
        badge.hidden = false;
      }

      const perks = this.querySelector('[data-km-upsell-perks]');
      if (perks) {
        perks.replaceChildren();
        const perkItems = rule.perks && rule.perks.length ? rule.perks : defaultPerks(rule);
        perkItems.forEach((perk) => {
          const item = document.createElement('li');
          item.className = 'km-cart-upsell__perk';
          item.textContent = perk;
          perks.appendChild(item);
        });
      }

      const note = this.querySelector('[data-km-upsell-replacement-note]');
      if (note) {
        note.textContent = rule.replacementNote || '';
        note.hidden = !rule.replacementNote;
      }

      if (this.acceptButton) this.acceptButton.textContent = rule.cta;
      this.setStatus('');
      this.hidden = false;
    }

    setLoading(loading) {
      this.classList.toggle('is-loading', loading);
      if (this.acceptButton) this.acceptButton.disabled = loading;
      if (this.dismissButton) this.dismissButton.disabled = loading;
    }

    setStatus(message) {
      const status = this.querySelector('[data-km-upsell-status]');
      if (!status) return;
      status.textContent = message || '';
      status.hidden = !message;
    }

    dismiss() {
      if (!this.rule) return;
      pushEvent('cart_upsell_dismiss', this.rule, { cart_value_before: this.cart ? this.cart.total_price : undefined });
      this.hidden = true;
    }

    async accept() {
      if (!this.rule || this.classList.contains('is-loading')) return;

      const rule = this.rule;
      const before = this.cart ? this.cart.total_price : undefined;
      pushEvent('cart_upsell_accept', rule, { cart_value_before: before });
      this.setLoading(true);
      this.setStatus(rule.type === 'replacement' ? 'Updating your bundle…' : 'Adding to your cart…');

      try {
        let finalCart;

        if (rule.action === 'change_plan') finalCart = await this.changePlan(rule);
        else if (rule.action === 'replace_variant') finalCart = await this.replaceVariant(rule);
        else if (rule.action === 'add_bundle_remove_standalone_serums') finalCart = await this.addBundleAndRemoveStandaloneSerums(rule);
        else finalCart = await this.addItem(rule);

        pushEvent('cart_upsell_success', rule, { cart_value_before: before, cart_value_after: finalCart.total_price });
        this.refreshDrawer(finalCart);
      } catch (error) {
        console.error('[KM cart upsell] Action failed', error);
        pushEvent('cart_upsell_error', rule, { cart_value_before: before, error_message: error.message });
        this.setStatus('We could not update your cart. Please try again.');
        this.setLoading(false);
      }
    }

    async addItem(rule, includeSections = true) {
      const item = { id: Number(rule.target.variantId), quantity: 1 };
      if (rule.sellingPlanId) item.selling_plan = Number(rule.sellingPlanId);

      const body = { items: [item] };
      if (includeSections) Object.assign(body, sectionsPayload());

      return requestJson(endpoint(addUrl()), { method: 'POST', headers: jsonHeaders, body: JSON.stringify(body) });
    }

    async changePlan(rule) {
      const cart = await requestJson(endpoint(cartUrl()));
      const index = cart.items.findIndex((item) => item.key === rule.sourceItem.key);
      if (index < 0) throw new Error('The original cart line could not be found.');

      const current = cart.items[index];
      const body = {
        line: index + 1,
        quantity: current.quantity,
        selling_plan: Number(rule.sellingPlanId),
        ...sectionsPayload(),
      };

      return requestJson(endpoint(changeUrl()), { method: 'POST', headers: jsonHeaders, body: JSON.stringify(body) });
    }

  async removeStandaloneSerumsInSingleUpdate(productIds) {
  const cart = await requestJson(endpoint(cartUrl()));
  const removeProductIds = new Set(productIds.map(Number));
  let foundStandaloneSerum = false;

  const updates = cart.items.map((item) => {
    if (removeProductIds.has(Number(item.product_id))) {
      foundStandaloneSerum = true;
      return 0;
    }

    return item.quantity;
  });

  if (!foundStandaloneSerum) {
    throw new Error('No original serum line items were found to remove.');
  }

  return requestJson(endpoint(updateUrl()), {
    method: 'POST',
    headers: jsonHeaders,
    body: JSON.stringify({
      updates,
      ...sectionsPayload(),
    }),
  });
}
    async addBundleAndRemoveStandaloneSerums(rule) {
      let added = null;

      try {
        const addResponse = await this.addItem(rule, false);
        added = addResponse && addResponse.items ? addResponse.items[0] : null;
        if (!added || !added.key) throw new Error('Shopify did not confirm the Serum Bundle.');

        const afterAdd = await requestJson(endpoint(cartUrl()));
        const replacementExists = afterAdd.items.some((item) => item.key === added.key);
        if (!replacementExists) throw new Error('The Serum Bundle was not found after it was added.');

    return await this.removeStandaloneSerumsInSingleUpdate(
  rule.removeProductIds
);
      } catch (error) {
        if (added && added.key) {
          try {
            await requestJson(endpoint(changeUrl()), {
              method: 'POST',
              headers: jsonHeaders,
              body: JSON.stringify({ id: String(added.key), quantity: 0 }),
            });
          } catch (rollbackError) {
            console.error('[KM cart upsell] Rollback failed', rollbackError);
          }
        }

        throw error;
      }
    }

    async replaceVariant(rule) {
      let added = null;

      try {
        const addResponse = await this.addItem(rule, false);
        added = addResponse && addResponse.items ? addResponse.items[0] : null;
        if (!added || !added.key) throw new Error('Shopify did not confirm the replacement item.');

        const afterAdd = await requestJson(endpoint(cartUrl()));
        const replacementExists = afterAdd.items.some((item) => item.key === added.key);
        if (!replacementExists) throw new Error('The replacement item was not found after it was added.');

        const body = { id: String(rule.sourceItem.key), quantity: 0, ...sectionsPayload() };
        return await requestJson(endpoint(changeUrl()), { method: 'POST', headers: jsonHeaders, body: JSON.stringify(body) });
      } catch (error) {
        if (added && added.key) {
          try {
            await requestJson(endpoint(changeUrl()), {
              method: 'POST',
              headers: jsonHeaders,
              body: JSON.stringify({ id: String(added.key), quantity: 0 }),
            });
          } catch (rollbackError) {
            console.error('[KM cart upsell] Rollback failed', rollbackError);
          }
        }

        throw error;
      }
    }

    refreshDrawer(cartState) {
      const drawer = document.querySelector('cart-drawer');
      if (drawer && typeof drawer.renderContents === 'function' && cartState.sections) {
        drawer.renderContents(cartState);
        return;
      }

      window.location.reload();
    }
  }

  if (!customElements.get('km-cart-upsell')) customElements.define('km-cart-upsell', KmCartUpsell);

  // Allows Intelligems to enable a block that is already present in the DOM.
  document.addEventListener('km-cart-upsell:enable', () => {
    document.querySelectorAll('km-cart-upsell').forEach((upsell) => {
      if (typeof upsell.activate === 'function') upsell.activate();
    });
  });

  // Background cart reconciliation only runs for the Intelligems variant group.
  document.addEventListener('click', (event) => {
    if (!isCartUpsellEnabled()) return;
    if (!event.target.closest('#cart-icon-bubble')) return;

    const upsell = document.querySelector('km-cart-upsell');
    if (upsell && typeof upsell.evaluate === 'function') upsell.evaluate();
  }, true);
})();
